// Who is signed in, and what the server said about itself when the page
// loaded. Filled in once at boot (App.tsx) and read everywhere.

export const session = {
  email: null as string | null,
  authRequired: false,
  /** Whether this account runs the server, and so may read /admin. */
  admin: false,
  clientId: null as string | null,
  analysisVersion: 0,
  engine: "",
  /** Fingerprint of the files this page loaded, as the server named them. */
  build: "",
};

/** What the app does when a request comes back signed out: show the gate. */
let signedOut: () => void = () => location.reload();

export function onSignedOut(handler: () => void): void {
  signedOut = handler;
}

export function showSignIn(): void {
  signedOut();
}
